import { useState } from 'react';
import { TextField, TextFieldProps, IconButton } from '@mui/material';
import { Controller } from 'react-hook-form';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

type FormInputProps = {
  control: any;
  name: string;
  rules?: any;
  error?: any;
  secured?: boolean;
};

type Props = FormInputProps &
  TextFieldProps & {
    handleChange?: (name: string, value: string) => void;
  };

export const FormInput = ({
  control,
  name,
  rules,
  error,
  handleChange: handleChangeProp,
  secured,
  ...textFieldProps
}: Props) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const inputType = secured && showPassword ? 'text' : 'password';
  const toggleIcon = showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({
        field: { onChange, value },
        fieldState: { error: fieldError },
      }) => {
        const hasError = !!error || !!fieldError;
        const errorMessage = fieldError?.message || null;

        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target;
          onChange(value);
          if (handleChangeProp) {
            handleChangeProp(name, value);
          }
        };

        return (
          <TextField
            type={!secured ? 'text' : inputType}
            onChange={handleChange}
            value={value}
            error={hasError}
            helperText={hasError ? errorMessage : ' '}
            {...textFieldProps}
            InputProps={
              secured
                ? {
                    endAdornment: (
                      <IconButton onClick={toggleShowPassword}>
                        {toggleIcon}
                      </IconButton>
                    ),
                  }
                : {}
            }
          />
        );
      }}
    />
  );
};
